import { getConfigs, IRequestConfig, axios } from './api'

export interface RotateScannerImagesResponse {
  success: boolean
  images: string[]
  failedIndices: number[]
}

export class ImagesService {
  private static endpoint = '/images/rotate-scanner'

  static rotateScannerImages(body: {
    images: string[]
    angle: number
  }): Promise<RotateScannerImagesResponse> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        this.endpoint,
        {},
      )
      configs.data = body

      axios(configs, resolve, reject)
    })
  }
}
